import { Field } from 'services/http/bi-tool/field'
import { Query } from 'services/http/bi-tool/query'

import { BarVisualizationOptions } from '../types'

export const generateBarOptions = (
  options: BarVisualizationOptions,
  query: Query,
  fields: Field[]
): BarVisualizationOptions => {
  const result = options

  const aggregation = query.aggregations?.length
    ? query.aggregations[query.aggregations.length - 1]
    : null
  const group = query.groups?.length
    ? query.groups[query.groups.length - 1]
    : null

  if (aggregation) {
    result.value = aggregation.field as string
  }

  if (group) {
    result.label = group.field as string
  }

  return result
}
